import { render, staticRenderFns } from "./EditSubAccountPower.vue?vue&type=template&id=14fc4a5b&scoped=true"
import script from "./EditSubAccountPower.vue?vue&type=script&lang=ts"
export * from "./EditSubAccountPower.vue?vue&type=script&lang=ts"
import style0 from "./EditSubAccountPower.vue?vue&type=style&index=0&id=14fc4a5b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14fc4a5b",
  null
  
)

export default component.exports